<template>
  <div class="page-item">
    <h1 class="title">Create Item</h1>

    <div class="box">
      <!-- NAME -->
      <div class="field">
        <label class="label">Name</label>
        <div class="control">
          <input v-model="form.name" class="input" type="text" />
        </div>
      </div>

      <!-- DESCRIPTION -->
      <div class="field">
        <label class="label">Description</label>
        <div class="control">
          <textarea v-model="form.description" class="textarea"></textarea>
        </div>
      </div>

      <!-- TYPE -->
      <div class="field">
        <label class="label">Type</label>
        <div class="control">
          <div class="select is-fullwidth">
            <select v-model="form.type">
              <option value="product">Product</option>
              <option value="service">Service</option>
            </select>
          </div>
        </div>
      </div>

      <!-- UNIT PRICE -->
      <div class="field">
        <label class="label">Unit price (€)</label>
        <div class="control">
          <input
            v-model.number="form.unit_price"
            class="input"
            type="number"
            step="0.01"
          />
        </div>
      </div>

      <!-- UNIT CODE -->
      <div class="field">
        <label class="label">Unit</label>
        <div class="control">
          <div class="select is-fullwidth">
            <select v-model="form.unit_code">
              <option value="PCE">Piece</option>
              <option value="HUR">Hour</option>
              <option value="DAY">Day</option>
              <option value="MON">Month</option>
              <option value="KGM">Kilogram</option>
              <option value="LTR">Liter</option>
              <option value="E48">Service</option>
              <option value="BOX">Box</option>
              <option value="PK">Package</option>
            </select>
          </div>
        </div>
      </div>

      <!-- MIN STOCK (only for product) -->
      <div class="field" v-if="form.type === 'product'">
        <label class="label">Minimum stock</label>
        <div class="control">
          <input
            v-model.number="form.minimum_stock"
            class="input"
            type="number"
          />
        </div>
      </div>

      <!-- ACTIVE -->
      <div class="field">
        <label class="checkbox">
          <input type="checkbox" v-model="form.is_active" />
          Active
        </label>
      </div>

      <!-- BUTTON -->
      <div class="field">
        <button class="button is-primary" @click="submit">Save</button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/utils/axios';

export default {
  name: 'AddItem',

  data() {
    return {
      form: {
        name: '',
        description: '',
        type: 'product',
        unit_price: 0,
        unit_code: 'PCE',
        minimum_stock: 0,
        is_active: true,
      },
    };
  },

  methods: {
    async submit() {
      try {
        console.log('Submitting form:', this.form);
        await api.post('/items/', this.form);

        this.$router.push('/dashboard/inventory');
      } catch (err) {
        console.error(err);
        alert('Error while creating item');
      }
    },
  },
};
</script>
